export const offerStatus = {
  draft: 'draft',
  published: 'published',
  waiting: 'waiting',
  validated: 'validated',
  cancelled: 'cancelled'
}

export const offerModes = {
  quickMode: 'quick_mode',
  choiceMode: 'choice_mode'
}



// WEBPACK FOOTER //
// ./src/settings/offers.js